import script from "./LoadingSpinner.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingSpinner.vue?vue&type=script&setup=true&lang=ts"

import "./LoadingSpinner.vue?vue&type=style&index=0&id=23e437ed&scoped=true&lang=css"

import exportComponent from "/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23e437ed"]])

export default __exports__